import React from 'react'
import EmployerNavbar from '../../../../components/Profile-navbar/employer-navbar'
import { FaBell, FaArrowLeft} from 'react-icons/fa'
import { Link } from 'react-router-dom'
import { Container } from 'react-bootstrap'

const EmployerNotifications = () => {
  return (
    <div>
      <EmployerNavbar/>
      <Container fluid className='p-0'>
          <div className='message-head py-3 mt-4'>
            <h1 className='ps-4'>Notifications</h1>
          </div>
          <div className='align-items-center text-center justify-content-center py-5 my-5'>
            <h1 className='inner-section-info mt-5 pt-5'>You have no Notifications yet</h1>
           <FaBell className='inner-section-envelope mb-5'/>
          </div>
      </Container>
    </div>
  )
}

export default EmployerNotifications
